import http from "./http-service"

export default class UserService {

  static getById(id) {
    return http.get(`users/${id}`)
  }

  static create(user) {
    return http.post("users", user)
  }

  static update(user) {
    return http.put("users", user)
  }

  static acceptUseTerms(userId, accepted) {
    return http.post("accept-use-terms", { userId, accepted })
  }
}